import httpClient from './httpClient';

const documentService = {
    getMemos() {
        return httpClient.get('/api/adv/notes-service');
    },
    getPayslips() {
        return httpClient.get('/api/adv/payslips');
    },
    getDocumentsToSign() {
        return httpClient.get('/api/adv/documents/unsigned');
    },
    getComponentBykeyword(params) {
        return httpClient.get('/api/components', {params:params})
    }
}

export default documentService;
